import { CompleteStylistFragment, StylistState, useStartBreakMutation } from 'drycut-graphql';
import { ForwardedButton, Modal } from 'ui-components';
import { useStylistCardContext } from '../StylistCardContext';

type Props = {
  stylist: CompleteStylistFragment;
};

type BreakOption = {
  label: string;
  value: number;
  internal: boolean;
};

export default function PauseButton({ stylist }: Props): React.ReactElement {
  const { toggleActions, actionLoading, setActionLoading, togglePauseDialog, pauseDialogOpen } =
    useStylistCardContext();
  const [startBreak, { loading }] = useStartBreakMutation();
  const options: Array<BreakOption> = [
    { label: '5 Minuten', value: 5 * 60, internal: false },
    { label: '20 Minuten', value: 20 * 60, internal: false },
    { label: '40 Minuten', value: 40 * 60, internal: false },
    { label: 'DRYCUT (20 Min)', value: 20 * 60, internal: true },
  ];

  async function handleBreakClick(option: BreakOption) {
    togglePauseDialog();
    setActionLoading(true);

    await startBreak({
      variables: {
        input: {
          stylistId: stylist.id,
          duration: option.value,
          internal: option.internal,
        },
      },
    });

    setActionLoading(false);
    toggleActions();
  }

  // The stylist should not be able to start a break if already on a break or waiting for customer
  const isDisabled =
    stylist.state === StylistState.Break ||
    stylist.state === StylistState.WaitingCustomer ||
    actionLoading;

  return (
    <div
      onClick={(event) => event.stopPropagation()}
      onMouseUp={(event) => event.stopPropagation()}
      onMouseDown={(event) => event.stopPropagation()}
    >
      <ForwardedButton
        fill="outlined"
        onClick={(event: React.MouseEvent) => {
          event.stopPropagation();
          togglePauseDialog();
        }}
        disabled={isDisabled}
        className="text-md w-full"
        loading={loading}
      >
        Pause
      </ForwardedButton>

      <Modal open={pauseDialogOpen} onClose={togglePauseDialog} title="Pause starten" closeButton>
        <div className="flex flex-col gap-3 w-64">
          {options.map((option) => (
            <button
              key={option.label}
              className="w-full p-3 text-center border border-gray-200 hover:bg-primary-600 hover:text-white transition-colors"
              onClick={() => handleBreakClick(option)}
            >
              {option.label}
            </button>
          ))}
        </div>
      </Modal>
    </div>
  );
}
